import { Button, Drawer, DrawerBody, DrawerCloseButton, DrawerContent, useDisclosure } from "@chakra-ui/react";
import { useDeviceSize } from "hooks";
import { useRouter } from "next/router";
import { useEffect, useRef } from "react";
import { useMobileMenuStore } from "stores/MobileMenuStore";
import { SideMenuIcon } from "styles/icons";
import { SideMenu } from "./SideMenu";
import type { SideMenuProps } from "./types";

export const SideMenuWrapper = ({ pageHeading }: SideMenuProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { close: closeMobileMenu } = useMobileMenuStore();
  const { isMobile } = useDeviceSize();

  const btnRef = useRef();
  const { events } = useRouter();

  useEffect(() => {
    events.on("hashChangeStart", onClose);

    return () => {
      events.off("hashChangeStart", onClose);
    };
  }, [events, onClose]);

  if (!isMobile) return null;

  return (
    <>
      <Button
        ref={btnRef}
        onClick={() => {
          onOpen();
          closeMobileMenu();
        }}
        aria-label="Open list of contents"
        variant="unstyled"
        color="primary.900"
        minH="initial"
        h={8}
        minW="initial"
        mr={5}
      >
        <SideMenuIcon w={7} />
      </Button>
      <Drawer
        isOpen={isOpen}
        placement="right"
        onClose={() => {
          onClose();
          closeMobileMenu();
        }}
        finalFocusRef={btnRef}
        size="sm"
      >
        <DrawerContent>
          <DrawerCloseButton borderRadius="50%" size="lg" _hover={{ color: "primary.500" }} />
          <DrawerBody mt={16}>
            <SideMenu pageHeading={pageHeading} />
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
};
